import axiosInstance from '../../../../config/axiosInstance';
const  VersionService = {
    async GetAllVersion() {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetAllVersion?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
              //  redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetVersionModules(VersionID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetVersionModules?VersionID=${VersionID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                //redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    
};

export default VersionService;